import type { BlockContent } from "../../../lib/blockContentSchemas";

/**
 * Buttons whose settings should open when they next appear: a new button
 * block (index 0), or a second button just added (index 1).
 */
export const pendingButtonSettings = new Map<string, number>();
export const openButtonSettings = (sourceBlockId: string, index: number) =>
  pendingButtonSettings.set(sourceBlockId, index);

/** A second button for a block with one: Outline, beside the main action. */
export const withSecondButton = (content: BlockContent<"button">): BlockContent<"button"> => ({
  ...content,
  buttons: [...content.buttons.slice(0, 1), { label: "See my work", style: "outline" }],
});

/**
 * What someone typed as a link: an email address, a web address (https://
 * added when left off), or neither.
 */
export function parseLink(text: string): string | null {
  const value = text.trim();
  if (/^mailto:/i.test(value)) return value;
  if (/^[^\s@/]+@[^\s@/]+\.[^\s@/]+$/.test(value)) return `mailto:${value}`;
  if (/^https?:\/\/\S+$/i.test(value)) return value;
  if (/^[^\s/]+\.[a-z]{2,}(\/\S*)?$/i.test(value)) return `https://${value}`;
  return null;
}

/** A section's anchor on the live site, which a button can scroll to. */
export const sectionAnchor = (sourceBlockId: string) => `section-${sourceBlockId.slice(0, 8)}`;

/** A section a button can link to: named by its first words. */
export type SectionTarget = { id: string; label: string };
